export type DirectiveFunc= (el:HTMLElement,value:any,mods:string[],redraw:()=>Promise<void>) => (nv:any)=> void;

export const Directives=new Map<string,DirectiveFunc>;

declare type MyFileItem = { name: string, size: number, type: string, lastModified: number };
declare type MyFileInputValue = { id: string, files: MyFileItem[] };

Directives.set("validity", (el:HTMLElement,v:any,mods:string[],redraw:()=>Promise<void>) => {
    // <input #validity=${"error message"}>
    const inp=<HTMLInputElement>el;
    function SetIt(v:any) {
      if(typeof v !=="string") throw new Error("Katla: #validity value must be string");
      inp.setCustomValidity(v);
    }
    SetIt(v);
    return SetIt;
  });

  
Directives.set("ref", (el:HTMLElement,v:any,mods:string[],redraw:()=>Promise<void>) => {
    if(typeof v !=="function") throw new Error("Katla: #ref value must be function");
    v(el);
    return ()=>{}
  });


Directives.set("bind",(el:HTMLElement,bindTo:any,mods:string[],redraw:()=>Promise<void>) => {
  let tp=el.tagName.toLowerCase();
  if(tp==="input") {
    tp=(<HTMLInputElement>el).type;
    if(!tp) tp="text";
    tp=tp.toLowerCase();
  }

  let BoundVal:any;
  let SetVal:(v:string|number|boolean|MyFileInputValue)=>void;
  let LastVal:any;
  
  const DoTrim=mods.indexOf("notrim")<0 && (el.tagName=="TEXTAREA" || (
      el.tagName=="INPUT" && ["text", "email", "search", "url"].includes((<HTMLInputElement>el).type)));

  function GetValueValue():string|number {
    let vv:string|number=(<HTMLInputElement>el).value;
    if(tp==="number" || tp==="range" || mods.indexOf("number")>=0) vv=parseInt(vv);
    if(DoTrim) vv=(<string>vv).trim();
    return vv;
  }

  function SetElemProp() {
    SetVal=undefined;
    if(Array.isArray(bindTo) && bindTo.length===2) {
      if (Array.isArray(bindTo[0]) && typeof bindTo[1]==="number") {
        // #bind=${[Array,number]} 
        BoundVal=bindTo[0][bindTo[1]];
        SetVal=v=>bindTo[0][bindTo[1]]=v;
      } else if (typeof bindTo[0]==="object" && typeof bindTo[1]==="string") {
        // #bind=${[object,propName]} 
        if(!bindTo[0].hasOwnProperty(bindTo[1])) throw new Error("Katla: " + tp + " #bind to object does not have property '" + bindTo[1] + "'");
        BoundVal=bindTo[0][bindTo[1]];
        SetVal=v=>bindTo[0][bindTo[1]]=v;
      } else if (typeof bindTo[0]==="function" && typeof bindTo[1]==="function") {
        // #bind=${[getFunc,setFunc]} - DEPRECATED
        BoundVal=bindTo[0]();
        SetVal=bindTo[1];
      } else if (typeof bindTo[1]==="function") {
        // #bind=${[value,setFunc]}
        BoundVal=bindTo[0];
        SetVal=bindTo[1];
      }
    } else if(Array.isArray(bindTo) && bindTo.length===1 && Array.isArray(bindTo[0])) {
        // #bind=${[Array]}
        if(tp!=="checkbox") throw new Error("Katla: Can only #bind to [Array] with input/checkbox"); 
        BoundVal=bindTo[0];
        SetVal=()=>{}; //dummy to prevent error
    } 
    if(!SetVal) throw new Error("Katla: Can only #bind to {object}.PropName / [Object,string] / [Array,number] / [value,setFunc] / [Array]");

    if(tp==="radio") {
      if(!el.hasAttribute("value")) throw new Error("Katla: input/radio element missing 'value' attribute - for #bind");
      let vv=GetValueValue(); 
      let value=BoundVal===vv;
      if(value===LastVal) return;
      (<HTMLInputElement>el).checked=value;
      LastVal=value;
    } else if(tp==="checkbox") {
      if(typeof BoundVal==="boolean") {
        if(BoundVal===LastVal) return;
        (<HTMLInputElement>el).checked=BoundVal; 
        LastVal=BoundVal;
        return; 
      } else {
        if(!Array.isArray(BoundVal)) throw new Error("Katla: #bind value for input/checkbox must be either boolean or array");
        if(!el.hasAttribute("value")) throw new Error("Katla: input/checkbox element missing 'value' attribute - for #bind with array value");
        let vv=GetValueValue(); 
        let value=BoundVal.indexOf(vv)>=0;
        if(value===LastVal) return;
        (<HTMLInputElement>el).checked=value;
        LastVal=value;
      }
    } else if (tp === "file") {
      if (!BoundVal || !BoundVal.files || (<MyFileInputValue>BoundVal).files.length === 0) (<any>el).value = ""; 
    } else {
      if(BoundVal===LastVal) return;
      (<HTMLInputElement>el).value= Number.isNaN(BoundVal) ? '': BoundVal.toString();
      LastVal=BoundVal;
    }
  }

  SetElemProp();

  function MyHandler(e:Event) {
    let vv=GetValueValue();
    if(tp==="radio") {
      if(!(<HTMLInputElement>el).checked) return;
      SetVal(vv);
      LastVal=vv;
    } else if (tp==="checkbox") {
      let ck=(<HTMLInputElement>el).checked;
      if(typeof BoundVal==="boolean") {
        SetVal(ck);
      } else {
        let i=BoundVal.indexOf(vv);
        if(ck && i<0) BoundVal.push(vv);
        if(!ck && i>=0) BoundVal.splice(i,1); 
      }
      LastVal=ck;
    } else if (tp==="file") {
      if (!el.id) el.id = 'file-' + (Math.floor(Math.random() * Date.now()).toString(36));
      SetVal({ id: el.id, files: Array.from((<HTMLInputElement>el).files).map(f => <MyFileItem>{ name: f.name, size: f.size, type: f.type, lastModified: f.lastModified }) });
    } else {
      SetVal(vv);
      LastVal=vv;
      if(DoTrim && e.type==="change" && (<HTMLInputElement>el).value!==LastVal) (<HTMLInputElement>el).value=LastVal;
    }

    if(mods.indexOf("noredraw")<0) redraw();
  }

  const HasEagerMod=mods.indexOf("eager")>=0;
  if(HasEagerMod) el.addEventListener("input", MyHandler);
  if(!HasEagerMod || DoTrim) el.addEventListener("change", MyHandler);

 
  return (nv:any)=>{ 
    bindTo=nv;
    SetElemProp();
  }
});

